<template>
  <div class="home">
    <shell @pageend="pageItems">
      <template v-slot:default>
        <div class="lg:w-full container m-auto">
          <div class="w-full lg:w-1/2 m-auto relative">
            <note-select :path="path" :tags="tags" type="Notes"/>
            <div class="px-2">
              <div class="m-auto">
                <div class="w-full">
                  <record-list :records="records" :path="path" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </shell>
  </div>
</template>
<script>
 import {mapState, mapActions} from 'vuex';
 import eventBus from '@/eventBus';

 import RecordList from '@/components/RecordList';
 import NoteSelect from '@/components/NoteSelect';
 import Shell from '@/components/Shell';

 export default {
   name: 'home',
   props: {
     path: {
       type: String,
       default: ''
     },

     tags: {
       type: Array,
       default: []
     },
   },
   data () {
     return {
       // path: this.$route.params.path,
       noteError: '',
       showOrganize: false,
       recordOffset: 0,
       text: '',
       isEnd: false,
       isInProgress: false
     }
   },

   components: {RecordList, Shell, NoteSelect},

   computed: {
     ...mapState({
       records: state => state.records
     })
   },

   async created () {
     await this.bootstrap();
     eventBus.$on('record', this.bootstrap);
   },

   destroyed () {
     eventBus.$off('record', this.bootstrap);
   },

   methods: {
     ...mapActions(['getRecords', 'getTags', 'getPaths']),

     async bootstrap () {
       this.getTags();
       this.getPaths();
       this.isInProgress = true;
       this.isEnd = false;
       this.recordOffset = 0;
       const res = await this.getRecords({
         path: this.path,
         tags: this.tags
       });

       if ((res && res.length < 10) || (res && res.err)) {
         this.isEnd = true;
       }

       this.isInProgress = false;
     },

     async pageItems (done = () => {}) {
       if (this.isInProgress || this.isEnd) {
         return done();
       }

       this.isInProgress = true;
       this.recordOffset = this.recordOffset + 1

       const res = await this.getRecords({
         path: this.path,
         tags: this.tags,
         page: this.recordOffset
       });

       if ((res && res.length < 10) || (res && res.err)) {
         this.isEnd = true;
       }

       this.$nextTick(() => {
         done()
         this.isInProgress = false;
       })
     },
     createSpellFromFilters () {
       this.$router.push({
         name: 'create-spell-email',
         query: {
           path: this.path,
           tags: this.tags
       }})
     }
   },

   watch: {
     $route (to) {
       if (to.name !== 'logout') {
         this.bootstrap();
       }
     }
   }
 }
</script>

